import { environment } from '../../../../environments/environment';
import { CagnotteService } from '../../../shared/services/cagnotte.service';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastyService } from 'ng2-toasty';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { DataTableTranslations, DataTableResource, DataTable } from 'angular-datatables-all-versions';
import { Jackpot } from '../../../shared/models/jackpot.interface';
import { IAssoc } from '../../../shared/models/association.interface';
import * as moment from 'moment';

@Component({
  selector: 'app-cagnottes-details',
  templateUrl: './cagnottes-details.component.html',
  styleUrls: ['./cagnottes-details.component.css']
})
export class CagnottesDetailsComponent implements OnInit {
  @ViewChild('dataTable', {static: false}) dataTable: DataTable;
  public site_url: string;
  public jackpot: Jackpot;
  public assocs: IAssoc[] = [];
  public cagnotteDetailsForm: FormGroup;
  public confirmModalRef: BsModalRef;
  public isCompany = false;

  public table_data = [];
  public table_data_resource: DataTableResource<Object>;
  public table_data_count = 0;
  public table_data_limit = 8;
  public table_translations = <DataTableTranslations>{
    indexColumn: 'Num.',
    expandColumn: 'Infos.',
    selectColumn: 'Sélectionner',
    paginationLimit: 'Max.',
    paginationText: 'Résultats: {from} - {to} / {total}',
    paginationTotalPages: '/'
  }

  public limits = [8, 16];

  constructor(private router: Router, private route: ActivatedRoute, private formBuilder: FormBuilder,
    private modalService: BsModalService, private toastyService: ToastyService, private service: CagnotteService) {
    this.jackpot = <Jackpot>this.route.snapshot.data['data'][0];
    this.assocs = this.route.snapshot.data['data'][1];

    this.cagnotteDetailsForm = this.formBuilder.group({
      'assoc_id_id': ['', Validators.required],
      'name': ['', Validators.required],
      'closing_date': ['', Validators.required],
      'created_at': ['', Validators.required],
      'description': ['', Validators.required]
    });

    this.table_data_resource = new DataTableResource(this.jackpot.charity_donations.filter(don => 'FAILED' !== don['payment_status']));
    this.site_url = environment.base_url;
  }

  ngOnInit() {
    this.cagnotteDetailsForm.patchValue(this.jackpot);
    this.cagnotteDetailsForm.controls['assoc_id_id'].setValue(this.jackpot.assoc.id);
    this.table_data_resource.count().then(count => this.table_data_count = count);
    this.checkAssocEditAbility();
  }

  reload(params) {
    let newParams = {...params};
    // To prevent internal error when the current page number < 1
    // if(this.dataTable.page<1) {
    //   this.dataTable.page = 1;
    //   newParams.offset = 0;
    // }
    this.table_data_resource.query(newParams).then(items => this.table_data = items);
  }

  onJackpotDetailsEditCancel(): void {
    const cagnotteType =  this.jackpot.pot_type === 'ENTERPRISE' ? 'company' : 'private';
    this.router.navigate(['/cagnottes/list/' + cagnotteType]);
  }

  onConfirm(template: TemplateRef<any>) {
    this.validateAllFormFields(this.cagnotteDetailsForm);
    this.checkIfStartDateLessThanToDate('created_at', 'closing_date');

    if (this.cagnotteDetailsForm.valid) {
      this.confirmModalRef = this.modalService.show(template, { class: 'modal-sm' });
    } else {
      let message = '';
      Object.keys(this.cagnotteDetailsForm.controls).forEach(key => {
        const controlErrors: ValidationErrors = this.cagnotteDetailsForm.get(key).errors;
        if (controlErrors != null) {
          if ('name' === key) {
            message += ' <br>- Le nom de la cagnotte est obligatoire';
          } else if ('closing_date' === key) {
            if (controlErrors.greater){
              message += ' <br>- La date de fin doit être plus grand que la date de début';
            } else {
             message += ' <br>- La date de fin est obligatoire';
            }
          } else if ('created_at' === key) {
              message += ' <br>- La date de début est obligatoire';
          } else if ('description' === key) {
            message += ' <br>- La description est obligatoire';
          }
        }
      })

      this.toastyService.error({
        title: 'Attention',
        msg: message,
        showClose: true,
        timeout: 5000,
        theme: 'bootstrap',
      })
    }
  }

  onConfirmRefused() {
    this.confirmModalRef.hide();
  }

  onSubmit(): void {
    (<any>Object).assign(this.jackpot, {
      assoc_id_id: this.cagnotteDetailsForm.value['assoc_id_id'],
      name: this.cagnotteDetailsForm.value['name'],
      closing_date: moment(this.cagnotteDetailsForm.value['closing_date']).endOf('day').format(),
      created_at: this.cagnotteDetailsForm.value['created_at'],
      description: this.cagnotteDetailsForm.value['description']
    });

    this.service.saveOrUpdate(this.jackpot)
      .subscribe(
        data => {
          this.toastyService.success({
            title: 'Success',
            msg: 'Cagnotte modifi&eacute;e avec succ&egrave;s',
            showClose: true,
            timeout: 5000,
            theme: 'bootstrap',
          })
        },
        () => {
          this.toastyService.error({
            title: 'Attention',
            msg: 'Une erreur s\'est produite, reessayer plus tard',
            showClose: true,
            timeout: 5000,
            theme: 'bootstrap',
          })
        }, () => {
          if (this.confirmModalRef) {
            this.confirmModalRef.hide();
          }
        });
  }

  private checkAssocEditAbility() {
    let paied = false;
    if ('ENTERPRISE' === this.jackpot.pot_type) {
      this.isCompany = true;
      paied = this.jackpot.donation ? (this.jackpot.donation.status === 'SUCCEEDED' ||
        this.jackpot.donation.status === 'CREATED') : false;
    } else {
      paied = this.jackpot.donators_count > 0;
    }

    if (paied) {
      this.cagnotteDetailsForm.controls['assoc_id_id'].disable();
    }
  }

  private validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  private checkIfStartDateLessThanToDate(fromDateKey: string, toDateKey: string) {
    const from = this.cagnotteDetailsForm.controls[fromDateKey];
    const to = this.cagnotteDetailsForm.controls[toDateKey];

    if (to.value < from.value) {
      to.setErrors({ greater: true });
    } else if (to.value === "") {
      to.setErrors({ invalid: true });
    } else if (to.value == null) {
      to.setErrors({ invalid: true });
    } else if (to.value == 'Invalid Date') {
      to.setErrors({ invalid: true });
    } else {
      to.setErrors(null);
    }
  }

}
